<div class="container-fluid pt-3">
  <div class="jumbotron bg-transparent">
    <h1 class="display-5">Quality Of Service</h1>
    <hr class="my-4">
    <p class="lead">The Quality Of Service capability enables easy onboarding to Supply Chain QoS Platform.</p>
  </div>
</div>
